import React from 'react';
import Styles from './styles.module.css';
import DefaultTitle from '../title';
import DefaultDesc from '../desc';

type DefaultInput2OvertimeProps = {
  title: string,
  hint?: any;
  setHintText?: (value: string) => void;
  error1: boolean,
  error2: boolean,
  value1: string,
  setValue1:(val: string) => void;
  value2: string,
  setValue2:(val: string) => void;
  unit: string,
  desc?: string,
};

const DefaultInput2Overtime: React.FC<DefaultInput2OvertimeProps> = ({ error1, error2, hint, setHintText, title, value1, setValue1, value2, setValue2, unit, desc, }) => {

  return (
    <>
    <DefaultTitle
      title={title}
      hint={hint}
      setHintText={setHintText}
    />
    <div className={Styles.input}>
      <div>
        <input style={error1 ? { border: ".5px solid #E31C5F" } : {}} placeholder='' value={value1} onChange={(e) => setValue1(e.target.value)} />
      </div>
      <p>円支給 /</p>
      <div>
        <input style={error2 ? { border: ".5px solid #E31C5F" } : {}} placeholder='' maxLength={3} value={value2} onChange={(e) => setValue2(e.target.value)} />
      </div>
      <p>時間分</p>
    </div>
    {desc && ( <DefaultDesc text={desc} /> )}
    </>
  );
}

export default DefaultInput2Overtime;
